module.exports = __webpack_public_path__ + "692c5d51318d5d2ecc5984b146b59edd.svg";